import {
  Col,
  Form,
  Input,
  Row,
  DatePicker,
  Select,
  Switch,
  Button,
} from 'antd';
import type { FormInstance } from 'antd';
import AddCategoryPage from './AddCategoryPage';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useParams } from 'react-router-dom';
// import Button from 'components/Button';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useUser } from 'contexts/User';
import { useMutation, useQuery } from 'react-query';
import ProductApi from 'apis/ProductApi';
import { IPortfolioPost } from 'interface/portfolio.interface';
import PortfolioApi from 'apis/PortfolioApi';
import moment from 'moment';
import PofTypeApi from 'apis/PofTypeApi';
import { IUser } from 'interface/user.interface';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import { get } from 'lodash';
interface Iparam {
  id?: string;
}

export default function CategoryInfoStepPage(): JSX.Element {
  const { id } = useParams<Iparam>();
  const history = useHistory();
  const { user } = useUser();
  const { TextArea } = Input;
  const { Option } = Select;
  const [form] = Form.useForm();
  const dateFormat = 'DD/MM/YYYY';
  const [users, setUsers] = useState<IUser[]>([]);

  const setStep = useCategoryManagementStore((state) => state.setStep);
  const [checkCategory, setCheckCategory] = useState<any>();
  // const [count, setCount] = useState(0);

  const { data: lstPofType } = useQuery(['getAll'], () => PofTypeApi.getAll());
  const { data: lstBrand } = useQuery(['getProductGroup'], () =>
    ProductApi.getProductGroup(3)
  );
  const { data: porfolioDetail, isLoading } = useQuery(
    ['get'],
    () => PortfolioApi.getDetail(id || ''),
    { enabled: !!id }
  );

  useEffect(() => {
    setStep(0);
    if (id) {
      const values = porfolioDetail?.data;
      if (values) {
        values.end_date = moment(values.end_date);
      }
      form.setFieldsValue(values);
    } else {
      form.setFieldsValue({
        pof_name: '',
        start_date: '',
        end_date: '',
        division_id: '',
        // product_group_id: '',
        // pof_type_code: '',
        allow_order_ni: false,
        cht_approve_date: '',
        description: '',
      });
    }
  }, [form, porfolioDetail]);

  const validateMessages = {
    required: '${label} không được để trống!',
  };

  const onNextStep = (values: IPortfolioPost) => {
    const params: IPortfolioPost = {
      pof_name: values.pof_name,
      pof_code: values.pof_code,
      start_date: new Date(),
      end_date: values.end_date,
      division_id: 1,
      list_product_group_id: values.list_product_group_id,
      pof_type_code: values.pof_type_code,
      allow_order_ni: values.allow_order_ni,
      cht_approve_date: values.cht_approve_date,
      description: values.description,
      effective_date: values.effective_date,
    };
    if (id) {
      params.id = id;
      PortfolioApi.put(params).then((res) => {
        if (res.success) {
          history.push(`/add-category/product-list-step/${id}`, {
            pof_type_code: params.pof_type_code,
          });
        }
      });
    } else {
      PortfolioApi.post(params).then((res) => {
        if (res.success) {
          history.push(`/add-category/product-list-step/${res.data.id}`, {
            pof_type_code: params.pof_type_code,
          });
        }
      });
    }
  };

  const SubmitButton = ({ form }: { form: FormInstance }) => {
    const [submittable, setSubmittable] = useState(true);
    console.log(submittable);

    // Watch all values
    const values = Form.useWatch([], form);

    useEffect(() => {
      form.validateFields({ validateOnly: true }).then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
    }, [values]);

    return (
      <Button
        className="py-3 px-5 h-12 rounded-lg text-white bg-primary-50"
        type="primary"
        htmlType="submit"
        disabled={!submittable}
      >
        <span className="text-base font-normal">Tiếp theo</span>
      </Button>
    );
  };

  const { mutate: getUser } = useMutation(RoleBasedAuth.getUsers, {
    onSuccess: (response) => {
      const values = form.getFieldsValue();
      const filteredFields = Object.keys(values).filter((key) =>
        key.includes('emails_')
      );
      const valuesArray = filteredFields.reduce(
        (acc, key) => acc.concat(values[key]),
        []
      );
      const resultArray = response.data.filter(
        (item) => !valuesArray.some((email) => email === item.email)
      );
      setUsers(resultArray);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  function ChangeCategory(event: any) {
    setCheckCategory(event);
  }

  const getProductGroupList = () => {
    if (id !== undefined) {
      return (porfolioDetail?.data?.product_group || []).map((item: any) => {
        return item?.grp_name;
      });
    }
  };

  return (
    <AddCategoryPage isLoading={isLoading}>
      <Form
        form={form}
        layout="vertical"
        className="items-center"
        onFinish={onNextStep}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Content>
          <div className="text-xl font-bold mb-6">1. Khai báo danh mục</div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Người tạo danh mục
                </Col>
                <Col className="" span={12}>
                  : {user?.fullName}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Email
                </Col>
                <Col className="" span={12}>
                  : {user?.email}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Chức danh
                </Col>
                <Col className="" span={12}>
                  : {user?.jobTitle}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Nhãn hàng quản lý
                </Col>
                <Col className="" span={12}>
                  :{' '}
                  {user?.productGroup
                    ?.map((group: any) => group.grp_name)
                    .join(', ')}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Khối phát hành
                </Col>
                <Col className="" span={12}>
                  : {user?.division}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Công ty phát hành
                </Col>
                <Col className="" span={12}>
                  : {user?.organization}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={3}>
              Đơn vị phát hành
            </Col>
            <Col className="" span={20}>
              : {user?.departmentName}
            </Col>
          </Row>

          <div className="my-4 border-2 border-dashed border-neutral-90"></div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form.Item
                name="pof_name"
                label="Tên danh mục phát hành"
                rules={[{ required: true }]}
              >
                <Input placeholder="Nhập tên danh mục" className="" />
              </Form.Item>
            </Col>
            <Col className="" span={12}>
              <Form.Item
                name="end_date"
                label="Ngày hết hạn"
                rules={[{ required: true }]}
              >
                <DatePicker
                  placeholder="dd/mm/yyyy"
                  className="ant-input"
                  format={dateFormat}
                  disabledDate={(current) => {
                    return moment().add(0, 'days') >= current;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form.Item
                name="pof_type_code"
                label="Loại danh mục"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Chọn"
                  onChange={(event) => ChangeCategory(event)}
                >
                  {lstPofType?.data?.map((item) => (
                    <Option value={item.pof_type_code} key={item.id}>
                      {item.pof_type_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="" span={12}>
              <Form.Item
                name="list_product_group_id"
                label="Bộ phận phát triển"
              >
                <Select
                  placeholder="Chọn nhãn hàng"
                  allowClear
                  mode="multiple"
                  defaultValue={id !== undefined ? getProductGroupList() : []}
                >
                  {lstBrand?.data?.map((item) => (
                    <Option value={item.id} key={item.id}>
                      {item.grp_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            {/* <Col className="" span={12}>
              <Form.Item
                name="cht_approve_date"
                label="Thời gian phê duyệt CHT"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Thời gian phê duyệt CHT"
                  options={[{ value: 2, label: '2 Ngày' }]}
                ></Select>
              </Form.Item>
            </Col> */}

            <div>{porfolioDetail?.data.allow_order_ni}</div>
            <Col className="" span={12}>
              <Form.Item
                name="allow_order_ni"
                label="Cho phép đặt hàng theo Ni"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>

            {/* <Col className="" span={12}>
              <Form.Item
                name="effective_date"
                label="Ngày hiệu lực"
                rules={[{ required: true }]}
              >
                <DatePicker
                  placeholder="dd/mm/yyyy"
                  className="ant-input"
                  format={dateFormat}
                  disabledDate={(current) => {
                    return moment().add(-1, 'days') >= current;
                  }}
                />
              </Form.Item>
            </Col> */}

            {checkCategory == 'suggest' && (
              <Col className="" span={12}>
                <Form.Item name="pof_co_manage" label="Đồng quản lý">
                  <Select
                    allowClear
                    mode="multiple"
                    placeholder="Nhập email"
                    showSearch={true}
                    options={
                      users == null || users == undefined
                        ? []
                        : users.map((item: any) => ({
                            label: item.fullName + ' - ' + item.jobTitle,
                            value: item.email,
                          }))
                    }
                    onSearch={(value) => {
                      getUser({ email: value });
                    }}
                    onBlur={(value) => {
                      setUsers([]);
                    }}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={24}>
              {/* <Form.Item name="description" label="Mô tả danh mục">
                <TextArea
                  showCount
                  maxLength={500}
                  rows={4}
                  placeholder="Nhập mô tả"
                />
              </Form.Item> */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                <Form.Item
                  rules={[{ required: false }]}
                  name="description"
                  label="Mô tả danh mục"
                  className="mb-0"
                >
                  <TextArea
                    required={false}
                    maxLength={500}
                    rows={4}
                    showCount
                    placeholder="Nhập mô tả"
                    style={{ marginRight: '10px' }}
                    // onChange={(e) => {
                    //   setCount(e.target.value.length);
                    // }}
                  />
                </Form.Item>

                {/* <div style={{ alignSelf: 'flex-start' }}>
                  <span
                    style={{
                      fontSize: '12px',
                      fontWeight: '400',
                      lineHeight: '14px',
                      letterSpacing: '0.15px',
                      color: '#8F9098',
                    }}
                  >
                    {count}/500 kí tự
                  </span>
                </div> */}
              </div>
            </Col>
          </Row>
        </Content>
        <Row
          className="mt-8"
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
        >
          <Col className="flex justify-end gap-2.5" span={8}>
            <Form.Item className="mr-2">
              <Button
                onClick={() => (window.location.href = '/category')}
                className="border-solid border border-primary-50 px-5 py-3 text-base h-12"
              >
                <span className="text-primary-50">Trở lại</span>
              </Button>
            </Form.Item>
            <Form.Item>
              {/* <Button type="submit">Tiếp theo</Button> */}
              {/* <SubmitButton form={form} /> */}
              <Button
                className="py-3 px-5 h-12 rounded-lg text-white bg-primary-50"
                type="primary"
                htmlType="submit"
              >
                <span className="text-base font-normal">Tiếp theo</span>
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </AddCategoryPage>
  );
}
